import React from 'react';
import { motion } from 'framer-motion';

const cardData = [
    {
        id: 1,
        image: "/assets/leverage/item1.png",
        title: "Comprehensive Support",
        description: "Reliable support with strong data privacy."
    },
    {
        id: 2,
        image: "/assets/leverage/item2.png",
        title: "Industry Expertise",
        description: "Industry-specific solutions for healthcare and finance."
    },
    {
        id: 3,
        image: "/assets/leverage/item3.png",
        title: "Customized Solutions",
        description: "Tailored applications designed for your workflow."
    }
];

const MaximizeEfficiency = () => {
    const containerVariant = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: { staggerChildren: 0.2 }
        }
    };

    const cardFadeUp = {
        hidden: { opacity: 0, y: 40 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } }
    };

    return (
        <section className="w-full lg:pb-[100px] pb-[60px] bg-white">
            <motion.div
                className="max-w-[1440px] mx-auto lg:px-[80px] px-[20px]"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
                variants={containerVariant}
            >
                <motion.h2
                    variants={cardFadeUp}
                    className="font-sora text-[20px] sm:text-[30px] font-[600] text-[#01386A] text-center mb-[40px] lg:mb-[60px] tracking-tight"
                >
                    Maximize Efficiency with ServiceNow
                </motion.h2>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[30px]">
                    {cardData.map((card) => (
                        <motion.div
                            key={card.id}
                            variants={cardFadeUp}
                            whileHover="hover"
                            className="group relative flex flex-col bg-white border border-[#E5ECFF] border-b-0 h-[420px] overflow-hidden cursor-pointer rounded-t-sm shadow-sm"
                        >
                            <div className="w-full h-[200px] overflow-hidden">
                                <img
                                    src={card.image}
                                    alt={card.title}
                                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                                />
                            </div>

                            <div className="p-[24px] sm:p-[30px] flex flex-col flex-1 bg-white relative z-10">
                                <h3 className="font-sora text-[16px] md:text-[20px] font-[600] text-[#01386A] mb-3">
                                    {card.title}
                                </h3>

                                <div className="mt-auto w-full flex flex-col">
                                    <div className="grid grid-rows-[0fr] group-hover:grid-rows-[1fr] transition-[grid-template-rows] duration-500 ease-in-out">
                                        <div className="overflow-hidden">
                                            <p className="font-graphik text-[14px] md:text-[16px] font-[500] text-[#49577A] leading-relaxed opacity-0 group-hover:opacity-100 transition-opacity duration-500 delay-100 pb-[16px]">
                                                {card.description}
                                            </p>
                                        </div>
                                    </div>

                                    <div className="flex items-center pt-[4px] pb-[4px]">
                                        <span className="font-graphik text-[14px] md:text-[16px] font-[500] text-[#01386A] border-b border-[#01386A] pb-[2px]">
                                            Read More
                                        </span>
                                        <span className="text-[#ED6800] ml-2 font-bold text-[16px]">&gt;</span>
                                    </div>
                                </div>
                            </div>

                            <div className="absolute bottom-0 left-0 w-full h-[4px] bg-[#01386A] z-20" />

                            <motion.div
                                className="absolute bottom-0 left-0 w-full h-[4px] bg-[#ED6800] z-30 origin-left"
                                initial={{ scaleX: 0 }}
                                variants={{
                                    hover: { scaleX: 1 }
                                }}
                                transition={{ duration: 0.4, ease: "easeInOut" }}
                            />
                        </motion.div>
                    ))}
                </div>
            </motion.div>
        </section>
    );
};

export default MaximizeEfficiency;